export const operatorOperatingRights = {
  fi: [
    {
      label: "Sähkö ja hissi",
      options: [
        {
          label: "Sähköasennustyöt ja sähkölaitekorjaus (A)",
          value: "A"
        },
        {
          label: "Hissityöt (H)",
          value: "H"
        },
        {
          label: "Sähkölaitekorjaus (L)",
          value: "L"
        },
        {
          label: "Oikeudet vain yhtiön omaan käyttöön (O)",
          value: "O"
        }
      ]
    },
    {
      label: "Paloturvallisuuslaiteliikkeet",
      options: [
        {
          label: "Paloilmoittimet (PI)",
          value: "PI"
        },
        {
          label: "Käsisammutinliikkeet (KS)",
          value: "KS"
        },
        {
          label: "Aerosolisammutuslaitteistot (SA A)",
          value: "SA A"
        },
        {
          label: "Kaasusammutinlaitteistot (SA K)",
          value: "SA K"
        },
        {
          label: "F- kaasulaitteistot (SA K F)",
          value: "SA K F"
        },
        {
          label: "Sprinklerilaitteistot (SA S)",
          value: "SA S"
        },
        {
          label: "Vesisumulaitteistot (SA V)",
          value: "SA V"
        },
        {
          label: "Vaahtosammutuslaitteistot (SA VA)",
          value: "SA VA"
        },
        {
          label: "Muut sammutuslaitteistot (SA M)",
          value: "SA M"
        },
      ]
    },
    {
      label: "Kylmälaitteet",
      options: [
        {
          label: "Kylmälaitteet alle 3 kg (E3)",
          value: "e3"
        },
        {
          label: "Kylmälaitteet vähintään 3 kg (Y3)",
          value: "y3"
        },
        {
          label: "Kylmälaitteet ajoneuvot (KU)",
          value: "ku"
        },
        {
          label: "Kylmälaitteet jätehuolto (JÄ)",
          value: "jä"
        },
        {
          label: "Kylmälaitteet vähintään 3 kg (A1)",
          value: "a1"
        },
        {
          label: "Kylmälaitteet alle 3 kg (A2)",
          value: "a2"
        },
        {
          label: "Kylmälaitteet hiilidioksidi (B)",
          value: "b"
        },
        {
          label: "Kylmälaitteet ammoniakki (C)",
          value: "c"
        },
        {
          label: "Ilmastointilaitteet ajoneuvot, korjaus (M1)",
          value: "m1"
        },
        {
          label: "Ilmastointilaitteet ajoneuvot, huolto (M2)",
          value: "m2"
        },
        {
          label: "Ilmastointilaitteet ajoneuvot, hiilidioksidi (M3)",
          value: "m3"
        }
      ]
    },
    {
      label: "Kaasu ja öljy",
      options: [
        {
          label: "Kaasu (A)",
          value: "A kaasu"
        },
        {
          label: "Öljy (A)",
          value: "A öljy"
        },
        {
          label: "Kaasu (C)",
          value: "C kaasu"
        },
        {
          label: "Öljy (C)",
          value: "C öljy"
        },
        {
          label: "Kaasu (P)",
          value: "P kaasu"
        },
        {
          label: "Öljy (P)",
          value: "P öljy"
        },
        {
          label: "Tarkastusliikkeet (öljysäiliöt)",
          value: "Tarkliike"
        },
        {
          label: "Muoviset maakaasuputket (PEputket)",
          value: "PE putki"
        }
      ]
    }
  ],
  sv: [
    {
      label: "Elektricitet och hissar",
      options: [
        {
          label: "Elinstallationsarbeten och reparation av elapparater (A)",
          value: "A"
        },
        {
          label: "Hissarbeten (H)",
          value: "H"
        },
        {
          label: "Reparation av elapparater (L)",
          value: "L"
        },
        {
          label: "Rättigheter endast för bolagets eget bruk (O)",
          value: "O"
        }
      ]
    },
    {
      label: "Installationsföretag inom räddningsväsendet",
      options: [
        {
          label: "Brandlarmanläggningar (PI)",
          value: "PI"
        },
        {
          label: "Handbrandsläckaraffärer (KS)",
          value: "KS"
        },
        {
          label: "Aerosolsläckanläggningar (SA A)",
          value: "SA A"
        },
        {
          label: "Gassläckningsanläggningar (SA K)",
          value: "SA K"
        },
        {
          label: "Släckanläggningar, F-gaser (SA K F)",
          value: "SA K F"
        },
        {
          label: "Sprinkleranläggningar (SA S)",
          value: "SA S"
        },
        {
          label: "Vattendimsystem (SA V)",
          value: "SA V"
        },
        {
          label: "Kumsläckanläggningar (SA VA)",
          value: "SA VA"
        },
        {
          label: "Övriga släckningsanläggningar (SA M)",
          value: "SA M"
        },
      ]
    },
    {
      label: "Kylanläggningar",
      options: [
        {
          label: "Kylanläggningar under 3 kg (E3)",
          value: "e3"
        },
        {
          label: "Kylanläggningar minst 3 kg (Y3)",
          value: "y3"
        },
        {
          label: "Kylanläggningar Fordon (KU)",
          value: "ku"
        },
        {
          label: "Kylanläggningar avfallshantering (JÄ)",
          value: "jä"
        },
        {
          label: "Kylanläggningar minst 3 kg (A1)",
          value: "a1"
        },
        {
          label: "Kylanläggningar under 3 kg (A2)",
          value: "a2"
        },
        {
          label: "Kylanläggningar koldioxid (B)",
          value: "b"
        },
        {
          label: "Kylanläggningar ammoniak (C)",
          value: "c"
        },
        {
          label: "Luftkonditionering fordon, reparation (M1)",
          value: "m1"
        },
        {
          label: "Luftkonditionering fordon, service (M2)",
          value: "m2"
        },
        {
          label: "Luftkonditionering fordon, koldioxid (M3)",
          value: "m3"
        }
      ]
    },
    {
      label: "Gaser och olja",
      options: [
        {
          label: "Gas (A)",
          value: "A kaasu"
        },
        {
          label: "Olja (A)",
          value: "A öljy"
        },
        {
          label: "Gas (C)",
          value: "C kaasu"
        },
        {
          label: "Olja (C)",
          value: "C öljy"
        },
        {
          label: "Gas (P)",
          value: "P kaasu"
        },
        {
          label: "Olja (P)",
          value: "P öljy"
        },
        {
          label: "Besiktningsaffärer (oljecisterner)",
          value: "Tarkliike"
        },
        {
          label: "Naturgasrörsystem av plast",
          value: "PE putki"
        }
      ]
    }
  ]
};

export const operatorOperatingRightsMapping = {
  A: "Sähköasennustyöt ja sähkölaitekorjaus (A)",
  H: "Hissityöt (H)",
  L: "Sähkölaitekorjaus (L)",
  O: "Oikeudet vain yhtiön omaan käyttöön (O)",
  PI: "Paloilmoittimet (PI)",
  "SA K": "Kaasusammutinlaitteistot (SA K)",
  "SA K F": "F- kaasulaitteistot (SA K F)",
  "SA S": "Sprinklerilaitteistot (SA S)",
  "SA V": "Vesisumulaitteistot (SA V)",
  "SA VA": "Vaahtosammutuslaitteistot (SA VA)",
  "SA M": "Muut sammutuslaitteistot (SA M)",
  KS: "Käsisammutinliikkeet (KS)",
  e3: "Kylmälaitteet alle 3 kg (E3)",
  y3: "Kylmälaitteet vähintään 3 kg (Y3)",
  ku: "Kylmälaitteet ajoneuvot (KU)",
  jä: "Kylmälaitteet jätehuolto (JÄ)",
  "A kaasu": "Kaasu (A)",
  "A öljy": "Öljy (A)",
  "C kaasu": "Kaasu (C)",
  "C öljy": "Öljy (C)",
  "P kaasu": "Kaasu (P)",
  "P öljy": "Öljy (P)",
  Tarkliike: "Tarkastusliikkeet (öljysäiliöt)",
  PE: "Muoviset maakaasuputket (PEputket)"
};

export const refigerationOperatingRights = {
  fi: [
    {
      label: "Alle 3 kg (E3)",
      value: "e3"
    },
    {
      label: "Vähintään 3 kg (Y3)",
      value: "y3"
    },
    {
      label: "Ajoneuvot (KU)",
      value: "ku"
    },
    {
      label: "Jätehuolto (JÄ)",
      value: "jä"
    },
    {
      label: "Sähköiset kytkinlaitteet (SK)",
      value: "sk"
    },
    {
      label: "Liuotinala (LI)",
      value: "li"
    },
    {
      label: "Sammutuslaitteistot (SA)",
      value: "sa"
    },
    {
      label: "Vuototarkastaja (VU A)",
      value: "vu a"
    },
    {
      label: "Kylmälaitteet vähintään 3 kg (A1)",
      value: "a1"
    },
    {
      label: "Kylmälaitteet alle 3 kg (A2)",
      value: "a2"
    },
    {
      label: "Kylmälaitteet hiilidioksidi (B)",
      value: "b"
    },
    {
      label: "Kylmälaitteet ammoniakki (C)",
      value: "c"
    },
    {
      label: "Ilmastointilaitteet ajoneuvot, korjaus (M1)",
      value: "m1"
    },
    {
      label: "Ilmastointilaitteet ajoneuvot, huolto (M2)",
      value: "m2"
    },
    {
      label: "Ilmastointilaitteet ajoneuvot, hiilidioksidi (M3)",
      value: "m3"
    },
    {
      label: "Ilmastointilaitteet ajoneuvot, talteenotto (M4)",
      value: "m4"
    },
    {
      label: "Vuototarkastaja (E A)",
      value: "e a"
    }
  ],
  sv: [
    {
      label: "Under 3 kg (E3)",
      value: "e3"
    },
    {
      label: "Minst 3 kg (Y3)",
      value: "y3"
    },
    {
      label: "Fordon (KU)",
      value: "ku"
    },
    {
      label: "Avfallshantering (JÄ)",
      value: "jä"
    },
    {
      label: "Elektriska brytare (SK)",
      value: "sk"
    },
    {
      label: "Lösningsmedelsbranschen (LI)",
      value: "li"
    },
    {
      label: "Släckanläggningar (SA)",
      value: "sa"
    },
    {
      label: "Läckagekontroll (VU A)",
      value: "vu a"
    },
    {
      label: "Kylanläggningar minst 3 kg (A1)",
      value: "a1"
    },
    {
      label: "Kylanläggningar under 3 kg (A2)",
      value: "a2"
    },
    {
      label: "Kylanläggningar koldioxid (B)",
      value: "b"
    },
    {
      label: "Kylanläggningar ammoniak (C)",
      value: "c"
    },
    {
      label: "Luftkonditionering fordon, reparation (M1)",
      value: "m1"
    },
    {
      label: "Luftkonditionering fordon, service (M2)",
      value: "m2"
    },
    {
      label: "Luftkonditionering fordon, koldioxid (M3)",
      value: "m3"
    },
    {
      label: "Luftkonditionering fordon, återvinning (M4)",
      value: "m4"
    },
    {
      label: "Läckagekontroll (E A)",
      value: "e a"
    }
  ]
};

export const pesticideInstructorCompetencies = {
  fi: [
    {
      label: "Kavinsuojelututkinnon järjestäjä",
      value: "KT"
    },
    {
      label: "Kasvinsuojelukoulutuksen ja tutkinnon järjestäjä",
      value: "KTT"
    }
  ],
  sv: [
    {
      label: "Anordnare av växtskyddsexamina",
      value: "KT"
    },
    {
      label: "Anordnare av växtskyddsutbildning och examina",
      value: "KTT"
    }
  ]
};

export const pestControlCompetencies = {
  fi: [
    {
      label: "Tuholaistorjunnan tutkinto",
      value: "TUT"
    },
    {
      label: "Tuholaistorjunnan erityistutkinto",
      value: "ETU"
    }
  ],
  sv: [
    {
      label: "Examen i skadedjursbekämpning",
      value: "TUT"
    },
    {
      label: "Specialexamen i skadedjursbekämpning",
      value: "ETU"
    }
  ]
};

export const pestControlOperators = {
  fi: [
    {
      label: "Tuholaistorjunnan tutkinnon järjestäjä",
      value: "YRTUT"
    },
    {
      label: "Tuholaistorjunnan erityistutkinnon järjestäjä",
      value: "YRETU"
    }
  ],
  sv: [
    {
      label: "Anordnare av växtskyddsexamina",
      value: "YRTUT"
    },
    {
      label: "Anordnare av växtskyddsutbildning och examina",
      value: "YRETU"
    }
  ]
};

export const pesticideInstructorEducationAreaOptions = {
  fi: [
    {
      label: "Peltoviljely",
      value: 1
    },
    {
      label: "Puutarhaviljely avomaalla",
      value: 2
    },
    {
      label: "Kasvihuoneviljely",
      value: 3
    },
    {
      label: "Golfkentät",
      value: 4
    },
    {
      label: "Viheralueet",
      value: 5
    },
    {
      label: "Metsätaimitarhat",
      value: 6
    },
    {
      label: "Metsänhoito",
      value: 7
    },
    {
      label: "Kasvinsuojeluaineiden myynti",
      value: 8
    }
  ],
  sv: [
    {
      label: "Åkerbruk",
      value: 1
    },
    {
      label: "Trädgårdsodling på friland",
      value: 2
    },
    {
      label: "Växthusodling",
      value: 3
    },
    {
      label: "Golfbanor",
      value: 4
    },
    {
      label: "Grönområden",
      value: 5
    },
    {
      label: "Skogsplantskolor",
      value: 6
    },
    {
      label: "Skogsvård",
      value: 7
    },
    {
      label: "Försäljning av växtskyddsmedel",
      value: 8
    }
  ]
};

export const pesticideInstructorOperationRightsOptions = [
  { label: "pesticideInstructorSearch.KT", value: "KT" },
  { label: "pesticideInstructorSearch.KTT", value: "KTT" }
];

export const pestControlCompetencyOptions = [
  { label: "pestControlCompetencySearch.BAT_TUT", value: "TUT" },
  { label: "pestControlCompetencySearch.BAT_ETU", value: "ETU" }
];

export const pestControlOperatorOptions = [
  { label: "pestControlOperatorSearch.YRTUT", value: "YRTUT" },
  { label: "pestControlOperatorSearch.YRETU", value: "YRETU" }
];

export const nameStampTypeOptions = [
  { label: "nameStampSearch.nameStampAll", value: "0" },
  { label: "nameStampSearch.nameStampLetter", value: "1" },
  { label: "nameStampSearch.nameStampImage", value: "2" },
];

export const booleanOptions = [
  { label: "common.booleanNull", value: null },
  { label: "common.booleanYes", value: "true" },
  { label: "common.booleanNo", value: "false" },
];

export const operationRightsArea = {
  KYL: "Kylmäalan pätevyys"
};


// WEBPACK FOOTER //
// ./src/constants.js